import React, { useState } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import './App.css';

const AUTH_KEY = 'geomech_user';

function App() {
  const [user, setUser] = useState(() => sessionStorage.getItem(AUTH_KEY));

  const handleLogin = (userId) => {
    sessionStorage.setItem(AUTH_KEY, userId);
    setUser(userId);
  };

  const handleLogout = () => {
    sessionStorage.removeItem(AUTH_KEY);
    setUser(null);
  };

  return (
    <div className="app">
      {user ? (
        <Dashboard user={user} onLogout={handleLogout} />
      ) : (
        <Login onLogin={handleLogin} />
      )}
    </div>
  );
}

export default App;
